import React from 'react';
import { Space, Tag, Tooltip } from 'antd';

/**
 * Compact "what screen does this permission unlock" indicator for table
 * cells. One small tag per module (label only — routes go in the tooltip,
 * not the tag, since cramming full paths into the tag is what made this
 * column unreadable the first time). Caps visible tags so a permission on
 * many modules (e.g. a broad admin permission) doesn't blow out the row.
 */
export default function AffectsCell({ modules = [], maxVisible = 2 }) {
  if (!modules.length) {
    return <Tag color="orange">Action only</Tag>;
  }

  const visible = modules.slice(0, maxVisible);
  const rest = modules.slice(maxVisible);

  return (
    <Space size={[4, 4]} wrap>
      {visible.map((mod) => (
        <Tooltip key={mod.key} title={(mod.routes || []).join(', ') || undefined}>
          <Tag color="green">{mod.label}</Tag>
        </Tooltip>
      ))}
      {rest.length ? (
        <Tooltip title={rest.map((m) => m.label).join(', ')}>
          <Tag>+{rest.length} more</Tag>
        </Tooltip>
      ) : null}
    </Space>
  );
}
